<template>
  <div>
    <div class="card-header">
      <i class="fa fa-align-justify"></i> Previews
      <select v-model="search">
        <option disabled value="">Sort by Catalog</option>
          <option v-for="catalog in fetchCatalogs">{{catalog}}</option>
      </select>
    </div>

    <div class="card-group">
      <div class="card card-container" v-for="preview in previewsFilteredList">
        <multi-preview-item v-bind:list-previews="preview.previews" v-bind:codename="preview.codename" v-bind:icon="preview.icon"></multi-preview-item>
        <div class="card-body card-body-container">
          <h6 class="card-title">{{preview.name}}</h6>
          <p class="card-text">{{preview.catalog.name}}</p>
          <p class="card-text">
            <small class="text-muted">
              <router-link :to="{ name: 'Preview', params: {id: preview.id} }">{{preview.id}}</router-link>
            </small>
          </p>
        </div>
      </div>
    </div>

  </div>
</template>

<style lang="scss">
  .card-container {
    width: 320px;
    height: 447.6px;
  }
  .card-body-container {
    width: 320px;
    height: 127.6px;
  }
</style>

<script>
import previews from 'services/previews'
import LoadingRows from 'components/LoadingRows'
import MultiPreviewItem from 'components/MultiPreviewItem'

export default {
  name: 'previews',
  created () {
    this.fetchData()
  },
  data () {
    return {
      previews: [],
      loading: false,
      search: ''
    }
  },
  computed: {
    previewsFilteredList () {
      return this.previews.filter(preview => {
        return preview.catalog.name.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    fetchCatalogs () {
      var listPreviews = this.previews.map(function (preview) {
        return preview.catalog.name
      })

      return [...new Set(listPreviews)].sort()
    }
  },
  watch: {
    '$route': 'fetchData'
  },
  components: {
    LoadingRows,
    MultiPreviewItem
  },
  methods: {
    fetchData () {
      previews.all(this)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/previews/Previews.vue